import React, { Component } from 'react';
import { localize } from 'linksoft';

import ValidatedField from './validated-field';
import HeaderCell from '../common/header-cell';
import SearchInput from '../common/search-input';
import getPropertyValue from '../utils/property-extractor';
import contains from '../utils/contains';

const Resx = localize('App', 'Common');

class ErrorsDialog extends Component {

  state = {
    filters: {}
  }

  setFilter = (filter, value) => {
    const filters = { ...this.state.filters };
    filters[filter] = value;
    this.setState({ filters: filters });
  }

  filterRows = (element) => {
    const { filters } = this.state;
    let matched = true;
    let value;
    for (let property in filters) {
      value = getPropertyValue(element, property);
      matched = matched && contains(value, filters[property]);
    }

    return matched;
  };

  handleClose = () => {
    this.props.onClose();
  }

  render = () => {
    const { profileOverview } = this.props;
    const invalidLines = profileOverview.invalidLines;
    const paramHeaders = profileOverview.parameterHeaders;
    const renderErrorColumn = invalidLines.some(l => l.rowErrors.length > 0);

    return (
      <div className="ErrorsDialog">
        <table className="table table-hover table-with-filter dataTable no-footer">
          <thead>
            <tr>
              {renderErrorColumn ? <th></th> : null}
              <th><HeaderCell>{Resx.Common.Id}</HeaderCell></th>
              <th><HeaderCell>{Resx.App.MeasurementStatus}</HeaderCell></th>
              <th><HeaderCell>{Resx.App.MeasurementDate}</HeaderCell></th>
              {
                paramHeaders.map(p =>
                  <th key={p.nameResxKey}>
                    <HeaderCell>{p.isGeneric !== true ? Resx.App(p.nameResxKey) : `${Resx.App.Param} ${p.nameResxKey}` }</HeaderCell>
                  </th>
                )
              }
            </tr>
            <tr>
              {renderErrorColumn ? <th></th> : null}
              <th>
                <SearchInput onSearch={(text) => this.setFilter('referenceNumber', text)}></SearchInput>
              </th>
              <th>
                <SearchInput onSearch={(text) => this.setFilter('measurementStatus.value', text)}></SearchInput>
              </th>
              <th>
                <SearchInput onSearch={(text) => this.setFilter('measurementDate.value', text)}></SearchInput>
              </th>
              {
                paramHeaders.map((p, index) =>
                  <th key={`${p.nameResxKey}`}>
                    <SearchInput
                      onSearch={(text) => this.setFilter(`params[${index}].value`, text)}
                      transform={transformNumberToString}
                    ></SearchInput>
                  </th>
                )
              }
            </tr>
          </thead>
          <tbody>
            {
              invalidLines.filter(this.filterRows).map(e => renderRow(e, paramHeaders.length, renderErrorColumn))
            }
          </tbody>
          <tfoot>
          </tfoot>
        </table>
        <div className="panel-footer validation-buttons">
          <button className="btn btn-warning btn-sm btn-if" onClick={this.handleClose}>{Resx.Common.Close}</button>
        </div>
      </div>
    );
  };
}

const renderRow = (line, paramHeadersCount, renderErrorColumn) => {
  const hasLineErrors = line.rowErrors.length > 0;
  const errorMessages = line.rowErrors.join('\n');
  const params = line.parameters;
  const paramCount = params.length;
  for(let i = paramCount; i < paramHeadersCount; i++){
    params.push({
      parameterTypeId: i,
      value: '',
      name: `Param_${i}`
    })
  }

  return (
    <tr
      key={line.number}
      className={hasLineErrors === true ? 'is-error' : null}
      title={hasLineErrors === true ? errorMessages : null}
    >
      {hasLineErrors === true ? <td><i className='material-icons'>warning</i></td> : renderErrorColumn ? <td></td> : null}
      <ValidatedField field={line.referenceNumber}></ValidatedField>
      <ValidatedField field={line.measurementStatus}></ValidatedField>
      <ValidatedField field={line.measurementDate} isDatetime={true}></ValidatedField>
      {
        params.map(p =>
          <ValidatedField key={p.name} field={p}></ValidatedField>)
      }
    </tr>
  );
};

const transformNumberToString = (text) => {
  return text.replace(',', '.').replace(new RegExp(' ', 'g'), '');
}

export default ErrorsDialog;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/errors-dialog/errors-dialog.js